import { Injectable } from '@angular/core';
import { FrappeApp, FrappeCall } from 'frappe-js-sdk';
import { AppConstant } from '../../app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VisitorGateService {

  private frappe: FrappeApp;
    private frappeCall: FrappeCall;
    constructor(private http: HttpClient) {
        this.frappe = new FrappeApp(AppConstant.frappeUrl);
        this.frappeCall = this.frappe.call()
    }
    public uploadFile(url: string, file: File, args: any) {
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);
  
      for (const [key, value] of Object.entries(args)) {
        if (typeof value === 'string' || value instanceof Blob) {
          formData.append(key, value);
        } else {
  
          formData.append(key, String(value));
        }
      }
  
      return this.http.post(url, formData);
    }
    public createVisitorGatePass(data: any): Promise<any> {
      // Ensure the payload is wrapped in a { data: ... } structure
      const payload = {data: JSON.stringify(data)};
      return this.frappe.call().post('vendor_portal.api.create_visitor_gate_pass.create_visitor_gate_pass', payload);
  }

  public createVisitorGateOutPass(data: any): Promise<any> {
    // Ensure the payload is wrapped in a { data: ... } structure
    const payload = {data: JSON.stringify(data)};
    return this.frappe.call().post('vendor_portal.api.create_visitor_gate_out_pass.create_visitor_gate_out_pass', payload);
}

  
}
